// src/mobile/MobileHeritage.js
import React from "react";

const MobileHeritage = () => {
  return (
    <section
      style={{
        backgroundColor: "#f9fafb",
        padding: "30px 20px 40px",
        textAlign: "center",
        transition: "opacity 0.8s ease, transform 0.8s ease",
      }}
    >
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h3 style={{ marginBottom: "15px", color: "#0d2b3e" }}>
          Heritage Car Airports - Luxury Transportation
        </h3>
        <p style={{ color: "#1f2937", marginBottom: "15px" }}>
          Experience unparalleled luxury and comfort with Heritage Car Airports, your trusted transportation service for local and long-distance travel across Westchester County and beyond. We are committed to providing first-class service with a touch of elegance, ensuring every journey is seamless and memorable.
        </p>
        <h4 style={{ marginTop: "10px", color: "#0d2b3e" }}>Service Areas</h4>
        <ul style={{ listStyle: "none", padding: 0, margin: "10px auto", maxWidth: "500px", textAlign: "left" }}>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Northern and Southern Westchester</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Dutchess County</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Orange County</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Putnam County</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Rockland County</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Local and long-distance destinations</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>New York City</li>
        </ul>
        <h4 style={{ marginTop: "10px", color: "#0d2b3e" }}>Premium Airport Transfers</h4>
        <p style={{ marginBottom: "15px" }}>
          We provide reliable and punctual transfers to major airports, including:
        </p>
        <ul style={{ listStyle: "none", padding: 0, margin: "10px auto", maxWidth: "500px", textAlign: "left" }}>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>John F. Kennedy International Airport (JFK)</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Newark Liberty International Airport (EWR)</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>LaGuardia Airport (LGA)</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Westchester County Airport (HPN)</li>
          <li style={{ margin: "5px 0", color: "#1f2937" }}>Stewart International Airport</li>
        </ul>
      </div>
    </section>
  );
};

export default MobileHeritage;
